<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Date and time</th>
                    <th>Change</th>
                    <th>Changed by</th>
                    <th>Previous values</th>
                    <th>New values</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(f, index) in driver_history" :key="index">
                    <td>{{ f.date }}</td>
                    <td>{{ f.change }}</td>
                    <td>{{ f.changed_by_name }}</td>
                    <td>{{ f.prev_values }}</td>
                    <td>{{ f.new_values }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'driver_history',
    ],
}
</script>